import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../topic/redux/actions';

export class StyleTwoSectionTitle extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    let { Data, isColorW } = this.props;
    return (
      <div className="topic-style-two-section-title">
        <div className={isColorW ? 'style_two_title white flex_row' : 'style_two_title flex_row'} style={{ width: `${Data.width}`, background: `url(${Data.backgroundImg}) no-repeat`}}>{Data.title}</div>
        <div className={isColorW ? 'style_two_subtitle white' : 'style_two_subtitle'}>{Data.subtitle}</div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleTwoSectionTitle);



// WEBPACK FOOTER //
// ./src/features/style-two/StyleTwoSectionTitle.js